import React, { useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"
import { Menu, X } from "lucide-react"

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const navigationItems = [
    { name: 'Home', path: '/', hasDropdown: false },
    { name: 'Terms and Conditions', path: '/terms-of-service', hasDropdown: false },
    { name: 'Privacy-Policy', path: '/privacy-policy', hasDropdown: false },
  ]

  const handleNavigation = (item) => {
    if (item.path) {
      navigate(item.path)
      setIsMenuOpen(false)
    }
  }

  const isActiveRoute = (path) => {
    return location.pathname === path
  }

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="w-full px-3 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16 sm:h-20 md:h-24">
          {/* Logo */}
          <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer hover:scale-105 transition-all duration-300" onClick={() => navigate('/')}>
            <img 
              src="/TrackFam/trackfamlogo.png" 
              alt="TrackFam Logo" 
              className="h-12 sm:h-16 md:h-20 lg:h-24 w-auto"
            />
            <span className="text-lg sm:text-xl md:text-2xl font-bold text-[#62329f]">TrackFam</span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            {navigationItems.map((item, index) => (
              <button
                key={index}
                className={`px-3 py-2 text-sm font-bold text-black hover:text-[#62329f] transition-colors duration-200 ${
                  item.path && isActiveRoute(item.path) ? 'text-[#62329f]' : ''
                }`}
                onClick={() => handleNavigation(item)}
              >
                {item.name}
              </button>
            ))}
          </nav>

          {/* Right side - Buttons and Mobile Menu */}
          <div className="flex items-center space-x-4">
            {/* Desktop Buttons */}
            <div className="hidden lg:inline-flex items-center justify-center rounded-full bg-[#62329f] text-white font-semibold px-6 py-3 border-2 border-black shadow-[4px_4px_0_#000]">
              Get Started
            </div>

            {/* Mobile menu button */}
            <button
              className="lg:hidden p-2 rounded-md text-black hover:bg-gray-100 transition-colors duration-200"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200 shadow-lg">
          <div className="px-4 py-4 space-y-3 max-h-[calc(100vh-4rem)] overflow-y-auto">
            <nav className="space-y-1">
              {navigationItems.map((item, index) => (
                <button
                  key={index}
                  className={`w-full text-left px-4 py-3 text-sm font-bold text-black hover:text-[#62329f] hover:bg-gray-50 rounded-lg transition-all duration-200 ${
                    item.path && isActiveRoute(item.path) ? 'text-[#62329f] bg-purple-50' : ''
                  }`}
                  onClick={() => handleNavigation(item)}
                >
                  {item.name}
                </button>
              ))}
            </nav>
            
            {/* Mobile Buttons */}
            <div className="pt-3 border-t border-gray-200">
              {/* Get Started Button */}
              <button
                className="w-full inline-flex items-center justify-center rounded-full bg-[#62329f] text-white font-semibold px-6 py-3 border-2 border-black shadow-[4px_4px_0_#000] hover:shadow-[2px_2px_0_#000] transition-all duration-200"
                onClick={() => {
                  navigate('/signin-brand');
                  setIsMenuOpen(false);
                }}
              >
                Get Started
              </button>
            </div>
          </div>
        </div>
      )}
    </header>
  )
}
